import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.YandexMap__V2_1_GetYandexMap];

export const getQueryKey = (): QueryKey => [EQueryKeys.YandexMap__V2_1_GetYandexMap];
